import { default as axios } from "axios";

export default class LoginService
{
    static postLogin(body, config = {})
    {
        return axios.post('/login', body, config);
    }

    static postCodehash(body, config = {})
    {
        return axios.post('/codehash', body, config);
    }

}